import * as yup from 'yup';
import { FormInputMeta } from "@Modules/core/types/FormMetaType";
import { getValidationSchema } from "@Shared/utils/validationSchema";
import commonFormMeta from '@Shared/components/form/commonFormMeta';

export interface IMerchantPerActivityMeta{
  bank: FormInputMeta;
  activity: FormInputMeta;
  
  schema: any,
}

const MerchantPerActivityMeta: IMerchantPerActivityMeta = {} as IMerchantPerActivityMeta;

MerchantPerActivityMeta.bank = commonFormMeta.bank;
MerchantPerActivityMeta.activity = { 
  ...JSON.parse(JSON.stringify(commonFormMeta.activity)),
  label: "Activité Commerçant"};



MerchantPerActivityMeta.schema = yup.object().shape(getValidationSchema(MerchantPerActivityMeta));

export default MerchantPerActivityMeta;

